import React from "react";
import { getStressTone } from "../../services/usersClassesService";

export default function StressDot({ stress }) {
  const tone = getStressTone(stress);

  return (
    <span className="ac-uc-stressdot-wrap">
      <span className={`ac-uc-stressdot ${tone.dotClass}`} />
      <span className="ac-uc-stresslabel">{tone.label}</span>
    </span>
  );
}